import { largeTabletMin, tabletMin } from '@propertypal/shared/src/constants/mediaQueries';
import { styled } from 'styled-components';
import RichText from '../rich-text/RichText';

export const RoomsList = styled.dl`
  > :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const RoomCard = styled.dl<{ $hasImage: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin: 0;

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.keyline};
    padding-top: 30px;
  }

  @media (${tabletMin}) {
    grid-template-columns: ${({ $hasImage }) => ($hasImage ? '220px 1fr' : '1fr')};
  }

  @media (${largeTabletMin}) {
    grid-template-columns: ${({ $hasImage }) => ($hasImage ? '300px 1fr' : '1fr')};
  }

  @media print {
    grid-template-columns: ${({ $hasImage }) => ($hasImage ? '220px 1fr' : '1fr')};
  }
`;

export const RoomImageWrapper = styled.button`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: ${({ theme }) => theme.backgroundLighter};
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const RoomImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const RoomContent = styled.div`
  min-width: 0;
`;

export const RoomDetails = styled.dd`
  margin: 15px 0;
`;

export const RoomName = styled.dt<{ $mb?: number }>`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.theme.textDark};
  margin: 0;
  margin-bottom: ${({ $mb }) => ($mb ? `${$mb}px` : '0')};
`;

export const RoomMeta = styled.em`
  margin-bottom: 20px;
  display: block;
`;

export const RoomDescription = styled(RichText)`
  ul,
  ol {
    padding: 0 0 0 30px;

    & li {
      p {
        margin: 0;
      }
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }

    li::marker {
      color: ${({ theme }) => theme.textDark};
    }
  }
`;

export const EmptyState = styled.div`
  padding: 32px;
  text-align: center;
  color: ${({ theme }) => theme.textLight};
  background: ${({ theme }) => theme.backgroundLightest};
  border-radius: 8px;
`;
